"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteTag = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const fdr_combobox_styles_1 = require("./fdr-combobox.styles");
const FdrAutocompleteTag = props => {
    const { label = props.children, active = false, name, onRemove } = props;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const handleRemove = onRemove
        ? (event) => {
            event.stopPropagation();
            onRemove();
        }
        : undefined;
    return (react_1.default.createElement(fdr_combobox_styles_1.AutocompleteTagWrap, { "data-id": "tag", active: active },
        label,
        react_1.default.createElement(fdr_combobox_styles_1.RemoveButton, { role: "button", "data-id": "remove", variant: "iconBtn", icon: {
                name: 'close-outlined',
            }, onClick: handleRemove }, t('common:remove', { name }))));
};
exports.FdrAutocompleteTag = FdrAutocompleteTag;
//# sourceMappingURL=fdr-combobox-tag.js.map